import { atom } from 'recoil';

type Status = 'idle' | 'loading' | 'success' | 'error';

interface OrgAtom {
  status: { fetch: Status };
  data: any;
  error: any;
}

export const orgAtom = atom<OrgAtom>({
  key: 'orgAtom',
  default: {
    status: {
      fetch: 'idle',
    },
    data: {},
    error: {}
  },
});

interface OrgListAtom {
  status: { fetchList: Status };
  list: Array<object>;
  data: any;
  error: any;
}

export const inventoryAtom = atom<OrgListAtom>({
  key: 'orgListAtom',
  default: {
    status: {
      fetchList: 'idle',
    },
    list: [],
    data: {},
    error: {}
  },
});